<template>
  <div class="content component-reporter">
    <ol class="breadcrumb pull-right">
      <li class="breadcrumb-item">
        <a href="javascript:;">Home</a>
      </li>
      <li class="breadcrumb-item active">{{ $t('rfReporter.title') }}</li>
    </ol>
    <h1 class="page-header">
      {{ $t('app.name') }}
      <small>{{ $t('rfReporter.title') }}</small>
    </h1>
    <b-row>
      <b-col cols="12">
        <ct-reporter-widget/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CtReporterWidget from '@/components/RFReporter/ReporterWidget.vue';

export default {
  name: 'RFReporter',
  components: {
    CtReporterWidget,
  },
};
</script>

<style scoped lang="scss">

</style>
